import BeforeUnloadDialog from "./BeforeUnloadDialog";

export default BeforeUnloadDialog;
